import React, { Component } from 'react';
import { Field, withShouldComponentUpdate } from '../Forms';

class Textarea extends Component {
  render() {
    const { name, defaultValue, validate, required, id, className, placeholder } = this.props;
    return (
      <Field
        name={name}
        defaultValue={defaultValue}
        validate={validate}
        required={required}
        component={({ value, trigger })=> {
          return (
            <textarea
              id={id}
              className={className}
              name={name}
              placeholder={placeholder}
              value={value}
              onChange={(e)=> {
                trigger([
                  { type: 'onChange', value: e.target.value },
                  { type: 'onValidate' },
                  { type: 'onTouched' }
                ]);
              }}
              onBlur={(e)=> {
                trigger({
                  type: 'onDirty'
                });
              }}
            />
          )
        }}/>
    )
  }
}

export default withShouldComponentUpdate(Textarea);



// WEBPACK FOOTER //
// ./src/app/components/Forms/fields/Textarea.js